module.exports = __webpack_public_path__ + "static/assets/dbff6359a3f338d5581c626ee50acf60.svg";